<template src="./JobHistoric.html"></template>

<script>
import MyHistorics from "./MyHistoric/MyHistorics.vue";

export default {
  components: {
    "my-historics": MyHistorics,
  },
  data() {
    return {
      jobId: "",
      JobName: "",
      appointmentShow: false,
      bearerDefault: "",
      myHistoricsShow: false,
      jobSelected: [],
    };
  },
  mounted() {
    const vm = this;
    vm.bearerDefault = vm.$session.get("bearerDefault");
    vm.$session.set("bearerDefault", vm.bearerDefault);
    if (vm.$route.params) {
      vm.JobName = vm.$route.params.name.toUpperCase();
      vm.jobId = vm.$route.params.id.toUpperCase();
      vm.init();
      // vm.showHistoric();
    }
  },
  methods: {
    init() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5,
      });
      this.axios
        .get(this.$store.state.filooServer + "jobs/" + this.$route.params.id, {
          headers: { Authorization: this.$session.get("bearer") },
        })
        .then((response) => {
          if (response.status === 200) {
            this.jobSelected = response.data;
            this.$vs.loading.close(this.$refs.content);
          } else if (response.status === 204) {
            this.$vs.loading.close(this.$refs.content);
          }
        });
    },
    goToManageJobs() {
      const vm = this;
      vm.$session.set("bearer", vm.bearerDefault);
      vm.$session.start();
      vm.$router.push("/manage-jobs");
    },

    showHistoric() {
      const vm = this;
      vm.myHistoricsShow = true;
    },

    runJob() {
      this.myHistoricsShow = false;
       this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5,
      });
      this.axios
        .get(this.$store.state.filooServer + "jobs" + this.jobSelected.runUrl, {
          headers: { Authorization: this.$session.get("bearer") },
        })
        .then((response) => {
          if (response.status === 200) {
            console.log('resultado da execução do job: ', response)
            this.$vs.loading.close(this.$refs.content);
            this.myHistoricsShow = true;
          } 
        });

        
    },
  },
};
</script>

<style lang="scss" src="./JobHistoric.scss"></style>
